// @ts-strict-ignore
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';

import { CmsLayout } from 'modules/cms/layout/CmsLayout';
import { LoadingPage } from 'modules/main/pages/Loading';
import { NotFoundPage } from 'modules/main/pages/NotFound';
import { MainStoreState } from 'modules/main/store';
import { fetchPage } from 'modules/main/store/ducks/contents';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useAmpContext } from 'utils/AmpContext';
import { hasParam } from 'utils/url';

import { CmsAmpContentPage } from './CmsAmpContentPage';
import { CmsContentPage } from './CmsContentPage';

type Props = {
  slug: string;
  amp: boolean;
};

export default function CmsContentPageContainer({ slug, amp }: Props) {
  const dispatch = useMainDispatch();
  const location = useLocation<{ subsite?: string }>();
  const requestIsAmp = useAmpContext();

  const { contents, mainSearch } = useSelector((state: MainStoreState) => ({
    contents: state.contents,
    mainSearch: state.mainSearch,
  }));

  // @ts-expect-error fix me
  const { isLandingPage } = mainSearch || false;
  const contentObj = contents.byUrl[slug] || {};

  // @ts-expect-error fix me
  const { content } = contentObj;
  // @ts-expect-error fix me
  const pageState = contentObj.state || 'UNFETCHED';

  const hasHomePage = content && content.subsite && !!content.subsite.homePage;
  const heroSearch = content && content.heroSearch;

  const onlySearchResults = heroSearch && heroSearch.onlyResults;
  const onlyArticleResults =
    content && content.onlySearchResults && hasHomePage;

  useEffect(() => {
    if (!amp) {
      // @ts-expect-error fix types
      dispatch(fetchPage(slug));
    }
  }, [slug, amp, dispatch]);

  if (hasParam(location.search, 'saved')) {
    return (
      <Redirect
        to={`${location.pathname}${
          location.search ? `${location.search}&` : '?'
        }`}
      />
    );
  }

  if (
    onlySearchResults ||
    isLandingPage ||
    (onlyArticleResults && hasHomePage)
  ) {
    let qs = '?q=';
    if (location.search && location.search.includes('?q=')) {
      qs = location.search;
    } else if (location.search) {
      qs = `${location.search}&q=`;
    }

    return <Redirect to={`${location.pathname}${qs}`} />;
  }

  if (['FETCHING', 'UNFETCHED'].includes(pageState)) {
    if (amp) {
      // It's an AMP URL, but content is not already available.
      // Meaning it's disabled for that page.
      return <NotFoundPage />;
    }

    return <LoadingPage />;
  }

  // @ts-expect-error fix me
  if (content && contentObj.type === 'CMS_PAGE') {
    return (
      <CmsLayout content={content}>
        {requestIsAmp ? (
          <CmsAmpContentPage content={content} searchMode={false} />
        ) : (
          <CmsContentPage content={content} />
        )}
      </CmsLayout>
    );
  }

  return <NotFoundPage />;
}
